import { Avatar, Row } from "antd";
import { IPortalDocument } from "../../../types/Documents";
import { FileTextOutlined, LoadingOutlined } from "@ant-design/icons";
import { useDownload } from "../hooks/useDownload";
import { useCallback } from "react";
import dayjs from "../../../configs/dayjs";

type ItemProps = {
  values: IPortalDocument;
  downloadingItem: string | undefined;
  accountId: string;
  setDownloadingItem: React.Dispatch<React.SetStateAction<string | undefined>>;
};

export const Item = ({
  values,
  downloadingItem,
  accountId,
  setDownloadingItem,
}: ItemProps) => {
  const { onDownload } = useDownload(setDownloadingItem);

  const onClicked = useCallback(
    () => !downloadingItem && onDownload(values.id, values.name, accountId),
    [downloadingItem, onDownload, values.id, values.name, accountId],
  );

  return (
    <Row
      className="align-center pa-4 w-100 clickable-item justify-space-between logo-cursor"
      onClick={onClicked}
    >
      <Row className="align-center doc-desc">
        <Avatar
          icon={
            downloadingItem && downloadingItem === values.id ? (
              <LoadingOutlined className="text" />
            ) : (
              <FileTextOutlined className="text" />
            )
          }
          size={40}
          className="option d-flex justify-center"
        />
        <p className="my-0 text-md w-500 ml-4 elipsis" title={values.name}>
          {values.name}
        </p>
      </Row>
      <p className="my-0 text-md">{dayjs(values.date).format("MMM D, YYYY")}</p>
    </Row>
  );
};
